import { render, staticRenderFns } from "./Old_CombinedLabel.vue?vue&type=template&id=3f51c5a2&scoped=true"
import script from "./Old_CombinedLabel.vue?vue&type=script&lang=js"
export * from "./Old_CombinedLabel.vue?vue&type=script&lang=js"
import style0 from "./Old_CombinedLabel.vue?vue&type=style&index=0&id=3f51c5a2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f51c5a2",
  null
  
)

export default component.exports